import * as React from "react";
import { withStyles, WithStyles, Theme, createStyles, StyleRulesCallback } from "./mui/styles";
import { Button, ButtonProps } from "./widget";

const styles = ((theme: Theme) => createStyles({
    root: {
        margin: 2,
        color: 'rgba(0,0,0,0.44)',
        padding: 2,
        borderRadius: '50%',
        minHeight: 'unset',
        minWidth: 'unset'
    },
    rootSelected: {
        margin: 2,
        cursor: 'default',
        color: theme.palette.secondary.contrastText,
        padding: 2,
        borderRadius: '50%',
        minHeight: 'unset',
        minWidth: 'unset',
        backgroundColor: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        '&:active': {
            boxShadow: 'inherit',
        }
    },

    label: {
        minWidth: 24,
        minHeight: 24,
    }
})) as StyleRulesCallback;


export interface PaginationButtonProps extends ButtonProps {
    selected?: boolean;
}




class PaginationButton extends React.PureComponent<PaginationButtonProps & WithStyles<typeof styles>> {
    render() {
        const { classes, selected, ...other } = this.props;
        const color = selected ? "secondary" : undefined;
        const variant = selected ? "contained" : undefined;
        const rootClass = selected ? classes.rootSelected : classes.root;
        return <Button classes={{ label: classes.label, root: rootClass }} {...other} variant={variant}>{this.props.children}</Button>
    }
}

export default withStyles(styles)(PaginationButton);